module.exports = __webpack_public_path__ + "img/MaiGssello3.23108cd7.png";